import { GroupId } from '../../typings/groups';
import { PhrasesSelectorGeneratorGroupPhrases, PhrasesSelectorWizardId } from '../../typings/phrases';

export const ADD_PHRASES_GENERATOR_GROUP = 'ADD_PHRASES_GENERATOR_GROUP';
export type ADD_PHRASES_GENERATOR_GROUP = typeof ADD_PHRASES_GENERATOR_GROUP;

export interface AddPhrasesGeneratorGroupAction {
    type: ADD_PHRASES_GENERATOR_GROUP;
    groupId: GroupId;
}

export function addPhrasesGeneratorGroup(groupId: GroupId): AddPhrasesGeneratorGroupAction {
    return {
        type: ADD_PHRASES_GENERATOR_GROUP,
        groupId
    };
}

export const REMOVE_PHRASES_GENERATOR_GROUP = 'REMOVE_PHRASES_GENERATOR_GROUP';
export type REMOVE_PHRASES_GENERATOR_GROUP = typeof REMOVE_PHRASES_GENERATOR_GROUP;

export interface RemovePhrasesGeneratorGroupAction {
    type: REMOVE_PHRASES_GENERATOR_GROUP;
    index: number;
    groupId: GroupId;
}

export function removePhrasesGeneratorGroup(groupId: GroupId, index: number): RemovePhrasesGeneratorGroupAction {
    return {
        groupId,
        index,
        type: REMOVE_PHRASES_GENERATOR_GROUP
    };
}

export const CHANGE_PHRASES_GENERATOR_PHRASES = 'CHANGE_PHRASES_GENERATOR_PHRASES';
export type CHANGE_PHRASES_GENERATOR_PHRASES = typeof CHANGE_PHRASES_GENERATOR_PHRASES;

export interface ChangePhrasesGeneratorPhrasesAction {
    type: CHANGE_PHRASES_GENERATOR_PHRASES;
    groupId: GroupId;
    groupIndex: number;
    phrases: PhrasesSelectorGeneratorGroupPhrases;
}

export function changePhrasesGeneratorPhrases(
    groupId: GroupId,
    groupIndex: number,
    phrases: PhrasesSelectorGeneratorGroupPhrases
): ChangePhrasesGeneratorPhrasesAction {
    return {
        type: CHANGE_PHRASES_GENERATOR_PHRASES,
        groupId,
        groupIndex,
        phrases
    };
}

export const PHRASES_GENERATOR_GENERATE_PHRASES = 'PHRASES_GENERATOR_GENERATE_PHRASES';
export type PHRASES_GENERATOR_GENERATE_PHRASES = typeof PHRASES_GENERATOR_GENERATE_PHRASES;

export interface PhrasesGeneratorGeneratePhrasesAction {
    type: PHRASES_GENERATOR_GENERATE_PHRASES;
    wizardId: PhrasesSelectorWizardId;
}

export function phrasesGeneratorGeneratePhrases(
    wizardId: PhrasesSelectorWizardId
): PhrasesGeneratorGeneratePhrasesAction {
    return {
        type: PHRASES_GENERATOR_GENERATE_PHRASES,
        wizardId
    };
}

export type PhrasesSelectorGeneratorAction =
    | AddPhrasesGeneratorGroupAction
    | RemovePhrasesGeneratorGroupAction
    | ChangePhrasesGeneratorPhrasesAction
    | PhrasesGeneratorGeneratePhrasesAction;
